import axios from 'axios';

const fetchData = async (path) => {
  const response = await axios.get(path);
  return JSON.parse(JSON.stringify(response.data));
};

const postData = async (path, body) => {
  try {
    await fetch(path, {
      "method"     : "POST",
      "mode"       : "no-cors",
      "Content-Type" : "text/plain",
      "body" : JSON.stringify(body)
    });
  } catch (error) {
    console.error(error);
  }
};

const fetchPoolData = async (typeName) => {
  const poolData = await fetchData('/yolo/youareswimmer/assets/data/pool.json');
  const filteredData = poolData.reduce((acc, current) => {
    if (current.type.includes(typeName)) acc.push(current);
    return acc;
  }, []);
  return filteredData;
}

export {
  fetchData,
  postData,
  fetchPoolData
};
